<template>
  <div class="login-form">
    <div class="login-header">
      <h1 class="login-title" :style="getPrimaryColor">
        <i class="ph ph-user-switch"></i> Forgot Password
      </h1>
     
    </div>

    <div class="divider">
      <span class="line"></span>
      <span class="line"></span>
    </div>
    <el-form
      v-if="currentForm === 'default' && !isSettedPassword"
      class="log-form"
      :model="verification"
      ref="verification"
      @submit.native.prevent="verifyEmail('verification')"
    >
      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input
          v-model="verification.email"
          placeholder="Email or Mobile"
          autocomplete="off"
        ></el-input>
        <p class="error" v-if="getErrors && getErrors.email">
          {{ getErrors.verification_email }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row space-between">
          <el-button
            type="primary"
            size="medium"
            round
            native-type="button"
            class="login-button full-width"
            @click="verifyEmail('verification')"
            :loading="submitLoading"
            :style="getButtonStyles"
          >
            Click here to verify
          </el-button>
        </div>

          <div class="nav-link text-right">
        <router-link
          to="/signin/tenant"
          class="fw-bold"
          :style="getPrimaryColor"
        >
          Back to SignIn
        </router-link>
      </div>

      </el-form-item>

      <p
        class="error"
        v-if="getCompaniesByEmail && !getCompaniesByEmail.status"
      >
        {{ getCompaniesByEmail.message }}
      </p>
    </el-form>

    <!-- Verified Sign-In Form -->
    <el-form
      v-if="currentForm === 'VERIFIED' && !isSettedPassword"
      :model="signin"
      ref="signin"
      class="log-form"
      @submit.native.prevent="submitForm('signin')"
    >
      <h3>Welcome {{ getUserNameOfUser }}!</h3>

      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input
          v-model="signin.email"
          placeholder="Email or Mobile"
          disabled
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item class="mb-1" prop="workspace">
        Workspace <span class="text-danger">*</span>
        <el-select
          v-model="signin.workspace"
          filterable
          placeholder="Select"
          style="width: 100%"
        >
          <el-option
            v-for="item in getWorkspaceList"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          ></el-option>
        </el-select>
        <p class="error" v-if="getErrors && getErrors.workspace">
          {{ getErrors.workspace }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row space-between">
          <el-button
            type="primary"
            size="medium"
            round
            native-type="button"
            class="login-button full-width"
            @click="submitForm('signin')"
            :loading="submitLoading"
            :style="getButtonStyles"
          >
            Send Verfication Code
          </el-button>
        </div>
               <div class="nav-link text-right">
        <router-link
          to="/signin/tenant"
          class="fw-bold"
          :style="getPrimaryColor"
        >
          Back to SignIn
        </router-link>
      </div>

        
      </el-form-item>

      <p
        class="error"
        v-if="getCompaniesByEmail && !getCompaniesByEmail.status"
      >
        {{ getCompaniesByEmail.message }}
      </p>
    </el-form>

    <div v-if="isSettedPassword && !isForgotPassword">
      <!-- set password -->
      <el-form ref="form" @submit.native.prevent>
        <el-form-item label="Enter OTP">
          <el-input v-model="otp" placeholder="Enter otp"></el-input>
        </el-form-item>
        <!-- <span style="color: #5cb85c" v-if="successMessages.length">
                  {{ successMessages }}
                </span> -->
        <el-form-item label="Set Password" prop="password">
          <div class="password-input-wrapper">
            <el-input
              v-model="setPassword"
              placeholder="Set Password"
              :type="passwordType"
              autocomplete="off"
            ></el-input>

            <span
              class="password-toggle"
              @click="
                passwordType = passwordType === 'password' ? 'text' : 'password'
              "
            >
              {{ passwordType === "password" ? "SHOW" : "HIDE" }}
            </span>
          </div>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="password">
          <div class="password-input-wrapper">
            <el-input
              v-model="conformPassword"
              placeholder="Confirm Password"
              :type="confirmPasswordType"
              autocomplete="off"
            ></el-input>

            <span
              class="password-toggle"
              @click="
                confirmPasswordType =
                  confirmPasswordType === 'password' ? 'text' : 'password'
              "
            >
              {{ confirmPasswordType === "password" ? "SHOW" : "HIDE" }}
            </span>
          </div>
        </el-form-item>

        <span v-if="passwordErrors.length" style="color: red">
          {{ passwordErrors.join(",") }}
        </span>
        <el-form-item>
          

         
          <div class="forgot-login-row space-between mt-1">
            <el-button
              type="primary"
              size="medium"
              round
              native-type="button"
              class="login-button full-width"
              @click="checkPassword"
              :disabled="!otp"
              :loading="submitLoading"
              :style="getButtonStyles"
            >
              Reset Password
            </el-button>
          </div>


           <div class="d-flex justify-between align-center">
  <div class="nav-link text-right">
    <router-link
      to="/signin/tenant"
      class="fw-bold"
      :style="getPrimaryColor"
    >
      Back to SignIn
    </router-link>
  </div>

  <div
    class="nav-link text-right forgot-password-link"
    @click="resendVerificationCode"
    :class="{ disabled: isDisabled }"
    :style="{
      pointerEvents: isDisabled ? 'none' : 'auto',
      opacity: isDisabled ? 0.5 : 1,
    }"
  >
    {{ buttonText }}
  </div>
</div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserHelper from "@/mixins/UserHelper";
import WhiteLabelConfig from "@/config/app";
import CustomizationLayer from "@/mixins/CustomizationLayer";

export default {
  data() {
    return {
      isDisabled: false,
      timer: 30,
      intervalId: null,
      isSettedPassword: false,
      isEmailOpted: true,
      email: "",
      password: "",
      passwordErrors: [],
      passwordError: "",
      confirmPasswordType: "password",
      otp: "",
      setPassword: "",
      conformPassword: "",
      existedSigninEmail: "",
      password_rules: [
        {
          message:
            "Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol",
          regex:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
        },
      ],
      company_info: {},
      application_config: {},
      currentForm: "default",
      verification: {
        email: "",
      },
      signin: {
        email: "",
        password: "",
        workspace: "",
      },
      passwordType: "password",
      submitLoading: false,
      getErrors: null,
    };
  },
  mixins: [UserHelper, CustomizationLayer],
  computed: {
    ...mapGetters("company", ["getCompaniesByEmail"]),
    ...mapGetters("auth", ["getAuthenticationStatus", "getUserSignInErrors"]),
    ...mapGetters("applicationUsers", [
      "getUserVerifyDetails",
      "getUserEmailVerifyDetails",
      "getUserEmailVerificationErrors",
      "getUserSignInVerify",
      "getForgotAndResendVerify",
      "getForgotAndResendVerifyError",
    ]),
    getUserNameOfUser() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? `${companies.companies[0].first_name} ${companies.companies[0].last_name}`
        : "";
    },
    getEmail() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? companies.companies[0].email
        : "";
    },
    getWorkspaceList() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? companies.companies
        : [];
    },
    isEmailValid() {
      const email = this.verification.email?.trim().toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    buttonText() {
      if (this.isDisabled) {
        return `Resend ${this.isEmailOpted ? "verification OTP" : "OTP"} (${
          this.timer
        }s)`;
      }
      return `Resend ${this.isEmailOpted ? "verification OTP" : "OTP"}`;
    },
  },
  created() {
    // this.navigation();
  },
  mounted() {
   
    this.$store.commit("company/resetCompaniesByEmail");
    this.application_config = WhiteLabelConfig;
    // this.navigation();
  },
  methods: {
    async resendVerificationCode() {
      if (
        !this.contactDetails ||
        (!this.contactDetails.email && !this.contactDetails.phone)
      ) {
        this.$notify.error({
          title: "Error",
          message: "Cannot resend code: missing user contact details.",
        });
        return;
      }

      this.submitLoading = true;

      try {
        const payload = {
          company_id: this.signin.workspace,
          ...(this.contactDetails.email
            ? { email: this.contactDetails.email }
            : { phone: this.contactDetails.phone }),
        };

        await this.$store.dispatch(
          "applicationUsers/fetchForgotAndResendVerify",
          payload
        );

        if (this.getForgotAndResendVerify?.data?.status) {
          this.$notify({
            title: "Success",
            message:
              this.getForgotAndResendVerify?.message ||
              "OTP resent successfully!",
            type: "success",
          });
        } else {
          this.$notify.error({
            title: "Error",
            message:
              this.getForgotAndResendVerifyError?.message ||
              "Error resending verification code.",
          });
        }
      } catch (error) {
        this.$notify.error({
          title: "Error",
          message: "Something went wrong while resending verification code.",
        });
      } finally {
        this.submitLoading = false;
      }
      this.startTimer();
    },

    startTimer() {
      this.isDisabled = true;
      this.timer = 30;

      this.intervalId = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          clearInterval(this.intervalId);
          this.isDisabled = false;
        }
      }, 1000);
    },

    beforeDestroy() {
      if (this.intervalId) clearInterval(this.intervalId);
    },
    changeViewInput() {
      if (this.isEmailOpted) {
        this.isEmailOpted = false;
      } else {
        this.isEmailOpted = true;
      }
    },
    async checkPassword() {
      //this.loading = true;
      this.passwordError = "";
      this.passwordErrors = [];
      if (this.setPassword) {
        this.password_rules.forEach((rule) => {
          if (!rule.regex.test(this.setPassword)) {
            this.passwordErrors.push(rule.message);
          }
        });
        if (this.setPassword.length && this.conformPassword.length) {
          // this.checkConfirmPassword();
          if (this.setPassword != this.conformPassword) {
            this.passwordErrors.push("Password mismatch!");
            this.isSettedPassword = true;
          } else if (!this.passwordErrors.length) {
            await this.$store.dispatch(
              "applicationUsers/fetchUserEmailVerifyDetails",
              {
                ...(this.contactDetails &&
                  this.contactDetails._id && {
                    contact_id: this.contactDetails._id,
                  }),
                ...(this.signin &&
                  this.signin.email && {
                    email: this.signin.email,
                  }),
                verification_code: this.otp,
                password: this.setPassword,
              }
            );
            if (this.getUserEmailVerifyDetails) {
              //this.loading = false;
              this.$notify({
                title: "Success",
                message: "Password Updated Successfully!",
                type: "success",
              });
              this.isVerified = true;
              this.isSettedPassword = false;
              if (this.contactDetails.email) {
                this.signin.email = this.contactDetails.email;
              }
              if (
                this.getUserEmailVerifyDetails &&
                this.getUserEmailVerifyDetails.data
              ) {
                this.contactDetails = this.getUserEmailVerifyDetails.data;
              }
              this.$router.push({ path: "/signin/tenant" });
            } else {
              this.loading = false;
              this.passwordErrors = [];
              this.passwordErrors.push(
                this.getUserEmailVerificationErrors?.message ||
                  "Error while verifying"
              );
            }
          }
        }
      } else {
        this.passwordErrors.push("Password is required");
      }
    },

    async navigation() {
      if (this.getCompaniesByEmail?.status) {
        this.currentForm = "VERIFIED";
        this.signin.email = this.getEmail;
      }
    },
    async verifyEmail(formType, e) {
      if (e) e.preventDefault();
      this.verification.email = this.verification.email.trim().toLowerCase();
      if (!this.verification.email) {
        this.getErrors = { verification_email: "Email is required!" };
        return;
      }
      if (!this.isEmailValid) {
        this.getErrors = { verification_email: "Enter a valid email address!" };
        return;
      }

      this.getErrors = null; // Clear any existing errors

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;
        this.submitLoading = true;
        await this.$store.dispatch("company/fetchCompaniesByEmail", {
          email: this.verification.email,
        });
        if (this.getCompaniesByEmail?.status) {
          this.currentForm = "VERIFIED";
          this.signin.email = this.getEmail;
        }
        this.submitLoading = false;
      });
    },

    async submitForm(formType, isForgot = false) {
      console.log("resend");
      this.signin.email = this.signin.email.trim().toLowerCase();

      const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneFormat = /^(?:\+91|91)?\d{10}$/;

      if (!this.signin.email) {
        this.getErrors = { email: "Email or Mobile number is required!" };
        return;
      }

      if (!this.signin.workspace) {
        this.getErrors = { workspace: "Workspace (Company) is required!" };
        return;
      }

      const isEmail = emailFormat.test(this.signin.email);
      const isPhone = phoneFormat.test(this.signin.email);
      console.log("resend", isEmail, isEmail);
      if (!isEmail && !isPhone) {
        this.getErrors = { email: "Enter a valid Email or Mobile number!" };
        return;
      }

      this.getErrors = null;

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;

        this.submitLoading = true;

        try {
          const verifyPayload = {
            company_id: this.signin.workspace,
            ...(isEmail
              ? { email: this.signin.email }
              : { phone: this.signin.email }),
          };
          console.log("verifyPayload", verifyPayload);
          await this.$store.dispatch(
            "applicationUsers/fetchForgotAndResendVerify",
            verifyPayload
          );

          this.loading = true;

          if (this.getForgotAndResendVerify?.data?.status) {
            this.resendDetails = null;
            this.resendDetails = this.getForgotAndResendVerify?.data;
            this.successMessages = "";
            this.contactDetails = this.getForgotAndResendVerify.data;
            this.loading = false;
            this.startTimer();
            this.$notify({
              title: "Success",
              message:
                this.getForgotAndResendVerify?.message ||
                "OTP sent to your email!",
              type: "success",
            });
            this.successMessages = this.getForgotAndResendVerify?.message;
            if (
              this.getForgotAndResendVerify?.statusCode ==
              "account_not_verified"
            ) {
              if (isForgot) {
                this.isForgotPassword = true;
              } else {
                this.isSettedPassword = true;
              }
            } else if (
              this.getForgotAndResendVerify?.statusCode == "reset_password"
            ) {
              this.isForgotPassword = false;
              this.isSettedPassword = true;
            }
          } else {
            this.loading = false;
            this.VerificationErrors = "";
            this.VerificationErrors =
              this.getForgotAndResendVerifyError?.message ||
              "Error while verifying";
          }
        } catch (error) {
          this.$notify.error({
            title: "Error",
            message: "Something went wrong during sign in.",
          });
        } finally {
          this.submitLoading = false;
        }
      });
    },

    goToBuilder() {
      this.$router.push({ path: "/signin" });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  color: #196392 !important;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
}

.full-width {
  width: 100%;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider .line {
  height: 1px;
  width: 100%;
  background-color: #ccc;
}

.divider-text {
  padding: 0 10px;
}

.password-input-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error {
  color: red;
}
.password-input-wrapper {
  position: relative;
  display: block; /* Ensure vertical layout */
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 78%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color, #007bff);
  user-select: none;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.forgot-password-link {
  /* font-size: 14px;
  color: #000000; */
  text-decoration: none;
  /* font-weight: bold; */
  cursor: pointer;
  margin: 4px 0;
}

.forgot-password-link:hover {
  text-decoration: underline;
}
.disabled {
  cursor: not-allowed;
}
.el-form-item {
    margin-bottom: 0px !important;
}
.d-flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}

</style>
